<dialog-gala (clickClose)="hideModal()">
    <span gala-dialog-titre>{{titre}}</span>
    <div>
        <div class="row">
            <div class="col col-6">
                <input-gala #inputNuchep [(ngModel)]="nuchep" (ngModelChange)="changeInput()" [max]="8"
                    label="N° cheptel" appInputNumeric (initialized)="focusElem()" />
            </div>
            <div class="col col-6">
                @if (!this.isUpload && client){
                <div>
                    <menu-client [ligne]="true" [client]="client" (navigation)="hideModal()"><span
                            ligne-content></span></menu-client>
                </div>
                }
            </div>
        </div>
        <div class="row">
            <div class="col col-12">
                <input-gala [disabled]="true" value="{{client?.NOM}}" label="Nom" />
            </div>
        </div>
    </div>
    <div gala-dialog-actions>
        @if (this.isUpload){
        <button mat-stroked-button color="primary" [disabled]="!client" (click)="hideModal() ">Confirmer
            sélection</button>
        } @else {
        <button mat-stroked-button color="accent" (click)="hideModal()">Retour</button>
        }
    </div>
</dialog-gala>